export default function Affordable() {
    return (
        <section id="affordable">
  <div class="aff-label">Budget Friendly · No Compromise on Quality</div>
  <h2 class="aff-title">Great events for <em>every budget.</em></h2>
  <p class="aff-sub">We work with families from all walks of life. Whether you're planning a small intimate function or a 500-guest wedding, we fit our services to your budget — never the other way around. No hidden costs, no pressure. Just honest planning.</p>
  <div class="aff-pills">
    <div class="aff-pill">Transparent Pricing</div>
    <div class="aff-pill">No Hidden Charges</div>
    <div class="aff-pill">Budget Planning Support</div>
    <div class="aff-pill">Flexible Packages</div>
    <div class="aff-pill">Middle Class Friendly</div>
    <div class="aff-pill">Free Initial Consultation</div>
  </div>
</section>);}